import { initVueIslands } from "@solvari/common-fe/helpers";

function initExpertVueIslands() {
  initVueIslands({
    bolProductList: () => import("@/views/components/bol/ProductList.vue"),
    bolTextUrl: () => import("@/views/components/bol/TextUrl.vue"),
  });
}

export { initExpertVueIslands };
